import React from "react"
import { Link } from "gatsby"
import resolveLink from "../../utils/resolveLink"
import { StoreContext } from "src/context/store-context"

const CartButton = () => {

    const { checkout } = React.useContext(StoreContext)

    const items = checkout ? checkout.lineItems : []
  
    const quantity = items.reduce((total, item) => {
      return total + item.quantity
    }, 0)  

    return(
        <Link className="relative mx-3 text-2xl" to={resolveLink(`/cart`)} title="Cart">
            <i className="far fa-shopping-basket "></i>
            { quantity > 0 && <div className="absolute -right-2 -top-1 h-4 w-4 bg-red rounded-full text-xs text-white text-center font-semibold">{quantity}</div> }
        </Link>
    )
}

export default CartButton